/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import * as moment from 'moment';
import { NavigationExtras, Router } from '@angular/router';
import { LoadingController, NavController } from '@ionic/angular';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { SortPipe } from 'src/app/pipes/sort.pipe';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AccessService } from 'src/app/providers/access/access.service';

@Component({
  selector: 'app-patients',
  templateUrl: './patients.page.html',
  styleUrls: ['./patients.page.scss'],
  providers: [SortPipe]
})
export class PatientsPage implements OnInit {
  patientFilter: FormGroup;
  patientSearch: string;
  patientCount: number;
  user: any;
  patientlist: any[] = [];
  hasSkelton: boolean;
  page: number;
  perPage: number;
  filteredPatientList: any[] = [];
  hospitalList: any[] = [];
  nodata: boolean;
  hasMore: boolean;
  filter: any;
  descending: boolean = false;
  order: number;
  column: string = 'patient_first_name';
  currentSortProperty: string = 'patient_last_name';
  isAscendingSort: boolean = false;
  constructor(
    private loadingController: LoadingController,
    public formBuilder: FormBuilder,
    public storageService: StorageService,
    private eventsService: EventsService,
    public apiService: ApiService,
    public router: Router,
    public navCtrl: NavController,
    public toastService: ToastService,
    private sortPipe: SortPipe,
  public accessService: AccessService,

  ) {
    this.patientFilter = this.formBuilder.group({
      searchBar: [''],
      hospital: [''],
      admission_status: [0]
    });
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  ngOnInit() { 
    this.sortPatients('patient_last_name');
    this.getHospitalList();
    this.patientFilter.patchValue({admission_status:'2'});
  }

  sortPatients(property: string) {

    if (this.currentSortProperty === property) {
      // Toggle between ascending and descending order
      this.isAscendingSort = !this.isAscendingSort;
    } else {
      // Set ascending order by default when changing the sorting property
      this.isAscendingSort = true;
      this.currentSortProperty = property;
    }

    /* const sortOrder = this.isAscendingSort ? 'asc' : 'desc';
    this.filteredPatientList = this.sortPipe.transform(
      this.filteredPatientList,
      `${property}`,
      sortOrder
    ); */
    this.getPatientlist();
  }

  getHospitalList() {
    this.apiService.post('hospital-list', {}).subscribe(
      (res) => {
        if (res.error === false) {
          this.hospitalList = res.data.hospitals;
        }
      },
      (err) => { }
    );
  }

  filterPatients() {

    //console.log(this.patientFilter.controls.hospital.value);
    //console.log(this.patientFilter.controls.admission_status.value);

    this.getPatientlist();
  }

  getSortIcon(property: string): string {
    if (this.currentSortProperty === property) {
      return this.isAscendingSort ? 'caret-up-circle' : 'caret-down-circle';
    }
    return ''; // Default icon when not sorting by this property
  }

  getPatientlist() {
   this.hasSkelton = true;
   //console.log('this.ascending: ', this.isAscendingSort);
   //console.log('this.currentsortprop: ', this.currentSortProperty);

    const params = {
      patientName: this.patientFilter.controls.searchBar.value,
      hospital: this.patientFilter.controls.hospital.value,
      admission_status: this.patientFilter.controls.admission_status.value,
      sortdirection: this.isAscendingSort==false?'DESC':'ASC',
      sortby: 'Data.'+this.currentSortProperty,
    };
    let loading = null;
    this.loadingController.create({
      message: 'Loading Patients. Please wait...',
      spinner: "circles"
      // You can customize options here
    }).then((loadingInstance) => {
      loading = loadingInstance;
      loading.present();
      this.apiService.post('data/patient-count', params).subscribe(
        (res) => {
          if (res.error === false) {
            this.patientCount = res.patientCount;
            //console.log('conditionsarray: ',res.conditions);            
            //console.log('RES: ',res);
          }
        },
        (err) => {
        }
      );


    this.apiService.post('data/patient-list-v2', params).subscribe(
      (res) => {
        this.hasSkelton = false;
        if (res.error === false) {
          this.eventsService.setDoctorRole(res.data.anaesthetics, res.data.icu, res.data.physician, res.data.surgeon);
          this.patientlist = res.data.patients;
          //console.log(res.sort);
          //console.log(res.data);
          this.filteredPatientList = this.patientlist;
          loading.dismiss();
          //console.log('filteredPatientList: ', this.filteredPatientList);
          if (this.patientlist.length < this.perPage) {
            this.hasMore = false;
          } else {
            this.page++;
          }
        }
      },
      (err) => {
        this.hasSkelton = false;
        loading.dismiss();
      }
    );
  });  
  }

  doInfinite(infiniteScroll) {
    this.hasSkelton = true;
    if (this.hasMore) {
      const params = {
        page: this.page,
        perPage: this.perPage
      };
      this.apiService.post('data/patient-list', params).subscribe(
        (res) => {
          this.hasSkelton = false;
          if (res.error === false) {
            res.data.submissions.forEach((p) => {
              this.patientlist.push(p);
            });
            this.filteredPatientList = this.patientlist;
            if (res.data.submissions.length < this.perPage) {
              this.hasMore = false;
            } else {
              this.page++;
            }
            infiniteScroll.target.complete();
          }
        },
        async (err) => {
          this.hasSkelton = false;
          infiniteScroll.target.complete();
        }
      );
    } else {
      this.hasSkelton = false;
      infiniteScroll.target.complete();
      infiniteScroll.target.disabled = true;
    }
  }

  patientInfo(data) {
    this.storageService.set('state', 'patient');
    data.fromPatientList = true;
    const navigationExtras: NavigationExtras = {
      state: data
    };
    this.navCtrl.navigateForward('patientInfo', navigationExtras).then(() => this.eventsService.publish('PatientInfoEvent', data));
  }

  searchPatients(event: any): void {
    if (!event) {
      this.filteredPatientList = this.patientlist;
    }
    const newValue = event.target.value && event.target.value.trim().toLowerCase();
    this.patientSearch = newValue;
    if (!newValue || !this.patientlist) {
      this.filteredPatientList = this.patientlist;
    } else if (this.patientlist.length > 0 && typeof this.patientlist[0].Data.patient_first_name != 'undefined') {
      this.filteredPatientList = this.patientlist.filter((doctor) =>
        doctor.Data?.patient_first_name.toLowerCase().indexOf(newValue) > -1 || doctor.Data?.patient_last_name.toLowerCase().indexOf(newValue) > -1);
    }
  }
  goToAdvance() {
    this.storageService.set('state', 'patient');
    this.navCtrl.navigateForward('advanced');
  }

}
